<div class="offender-list-wrapper" *transloco="let t">

  <!-- Map toggle + legend + count -->
  <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
    <button type="button"
            class="btn locations-btn locations-btn--toggle locations-btn--sm"
            [ngClass]="{'locations-btn--active': isVisible}"
            (click)="toggleLayer.emit()"
            title="Toggle offender overlay on map">
      <span *ngIf="!isVisible">{{ t('Show on Map') }}</span>
      <span *ngIf="isVisible">{{ t('Hide from Map') }}</span>
    </button>
    <span class="locations-count">{{ filtered.length }} / {{ items.length }} records</span>
  </div>

  <!-- Search + Circuit (two columns) -->
  <div class="row g-2 mb-3 locations-filter-grid">
    <div class="col-12 col-md-6">
      <input class="form-control form-control-sm"
             [placeholder]="t('Search name, address, doc #...')"
             [(ngModel)]="search"
             (input)="applyFilters()" />
    </div>
    <div class="col-12 col-md-6">
      <select class="form-select form-select-sm w-100"
              [(ngModel)]="filterCircuit"
              (change)="applyFilters()">
        <option value="">{{ t('All Circuits') }}</option>
        <option *ngFor="let c of circuits" [value]="c">{{ c }}</option>
      </select>
    </div>
  </div>

  <!-- Offender cards -->
  <div class="offenders-list locations-scroll-area">

    <div *ngIf="pagedItems.length === 0" class="locations-empty-state">
      <span *ngIf="items.length === 0">Loading offender data...</span>
      <span *ngIf="items.length > 0">No offenders match your filters</span>
    </div>

    <div class="card locations-card mb-2"
         *ngFor="let o of pagedItems"
         [style.border-left]="'4px solid ' + addrTypeColor(o.addr_type)">

      <div class="card-header locations-card__header">
        <div class="d-flex align-items-center gap-2 locations-min-width-0 locations-card__title">
          <span *ngIf="o.addr_type === 'Transient'"
                class="locations-badge locations-badge--warning flex-shrink-0">
            {{ t('Transient') }}
          </span>
          <strong class="text-truncate">{{ titleCase(o.full_name) }}</strong>
        </div>
        <button *ngIf="o.latitude != null"
                type="button"
                class="btn locations-btn locations-btn--primary locations-btn--sm flex-shrink-0 ms-1"
                (click)="onView(o)"
                title="Fly to on map">
          {{ t('View') }}
        </button>
        <span *ngIf="o.latitude == null"
              class="locations-badge locations-badge--muted flex-shrink-0 ms-1">{{ t('No Location') }}</span>
      </div>

      <div class="card-body locations-compact-body">
        <div class="text-muted small text-truncate mb-1">
          {{ o.full_address || 'No address on file' }}
        </div>
        <div class="text-muted small">
          <span class="me-2"><strong>DOC #</strong> {{ o.doc_num }}</span>
          <span>{{ o.circuit_code }}</span>
        </div>
      </div>

    </div>
  </div>

  <!-- Pagination -->
  <div class="d-flex justify-content-between align-items-center mt-2 flex-shrink-0" *ngIf="totalPages > 1">
    <button class="btn locations-btn locations-btn--secondary locations-btn--sm" [disabled]="currentPage === 1" (click)="prevPage()">
      Prev
    </button>
    <span class="locations-count">Page {{ currentPage }} of {{ totalPages }}</span>
    <button class="btn locations-btn locations-btn--secondary locations-btn--sm" [disabled]="currentPage === totalPages" (click)="nextPage()">
      Next
    </button>
  </div>

</div>
